import { render, staticRenderFns } from "./RegistrationWizard.vue?vue&type=template&id=f0682140&scoped=true"
import script from "./RegistrationWizard.vue?vue&type=script&lang=ts"
export * from "./RegistrationWizard.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationWizard.vue?vue&type=style&index=0&id=f0682140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0682140",
  null
  
)

export default component.exports